export default (graphics =[]) => ({
	graphics,
	selectedGraphic: 0,
	selectedSize: 0,
	isSizeDropdownOpen: false,
	isMobileImageDropdownOpen: false,
	selectGraphicChanged() {
		this.selectedSize = 0;
	},
	getCurrentArrangementSrc() {
		debugger;
		return this.graphics[this.selectedGraphic]?.sizes[this.selectedSize]?.arrayngementSrc ?? 'assets/images/graphics-preview.png';
	},
});
